import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";

interface IGetAccommodationRatePlan {
  id?: number;
}

export interface IPostAccommodationRatePlan {
  title: string;
  code: string;
  days_valid?: number;
  base_price: number;
  public: boolean;
}

export interface IPutAccommodationRatePlan {
  id: number;
  title: string;
  code: string;
  public: boolean;
}

// GET Accommodation Rate Plans
export async function GetAccommodationRatePlans(params: IGetAccommodationRatePlan, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/accommodation/rate-plan"), params, useGlobalLoader);
}

// POST Accommodation Rate Plan
export async function PostAccommodationRatePlan(params: IPostAccommodationRatePlan, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/accommodation/rate-plan"), params, useGlobalLoader);
}

// PUT Accommodation Rate Plan
export async function PutAccommodationRatePlan(params: IPutAccommodationRatePlan, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/accommodation/rate-plan"), params, useGlobalLoader);
}

export interface IPutAccommodationRatePlanTaxLines {
  id: number;
  tax_line_ids: number[];
}
// PUT Accommodation Rate Plan Tax Lines
export async function PutAccommodationRatePlanTaxLines(
  params: IPutAccommodationRatePlanTaxLines,
  useGlobalLoader: boolean,
) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/accommodation/rate-plan/tax-lines"), params, useGlobalLoader);
}

export interface IPostAccommodationRatePlanTaxLines {
  rate_plan_id: number;
  tax_line_id: number;
}
// POST Accommodation Rate Plan Tax Lines
export async function PostAccommodationRatePlanTaxLines(
  params: IPostAccommodationRatePlanTaxLines,
  useGlobalLoader: boolean,
) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/accommodation/rate-plan/tax-lines"), params, useGlobalLoader);
}

export interface IDeleteAccommodationRatePlanTaxLines {
  rate_plan_id: number;
  tax_line_id: number;
}
// DELETE Accommodation Rate Plan Tax Lines
export async function DeleteAccommodationRatePlanTaxLines(
  params: IDeleteAccommodationRatePlanTaxLines,
  useGlobalLoader: boolean,
) {
  return await APIDelete(
    APIUrl(AdminType.FacilityAdmin, "/accommodation/rate-plan/tax-lines"),
    params,
    useGlobalLoader,
  );
}
